import {
  AfterViewInit,
  Component,
  inject,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { isEmpty, orderBy } from 'lodash-es';
import { DropdownModule } from 'primeng/dropdown';
import { HomePageService } from '../../services/home/home-page.service';
import { globalModules } from '../../utils/global-modules';
import { convertDateToCommonFormat } from '../../utils/utility-functions';
import { SidebarComponent } from '../sidebar/sidebar.component';
// import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';
import { FormsModule } from '@angular/forms';
import { filter } from 'rxjs';
import {
  LAST_REFRESH_DATE_URLS,
  PROJECT_ADMIN_URLS,
  SUPER_ADMIN_URLS,
} from 'src/app/core/constants';
import { HistoryService } from 'src/app/core/services/history/history.service';
import { AuthService } from '../../services/auth-service/auth.service';
import { MasterDataService } from '../../services/master-data/master-data.service';
import { ProjectService } from '../../services/project/project.service';
import { RoleService } from '../../services/role-service/role.service';
import { Project } from '../../types/ProjectData';
import { ColumnProps } from '../../types/TableProps';
import { AlertComponent } from '../alert/alert.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { TableComponent } from '../table/table.component';
import { DrawerComponent } from '../drawer/drawer.component';
import { AccordianComponent } from '../accordion/accordion.component';
import { CommonService } from '../../services/common/common.service';
import { FAQ } from '../../types/Faq';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    ...globalModules,
    SidebarComponent,
    NgbPopoverModule,
    TableComponent,
    AlertComponent,
    DropdownModule,
    FormsModule,
    ConfirmationDialogComponent,
    NotificationsComponent,
    DrawerComponent,
    AccordianComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent implements OnInit {
  visible: boolean = false;
  userName: string = '';
  userEmail: string = '';
  currentPath: string = '';
  isProfileOpen: boolean = false;
  // hasAccess: boolean = false;
  masterDataService = inject(MasterDataService);
  projectNameService = inject(ProjectService);
  assignedRoles: string[] = [];
  availableRoles: { id: string; value: string }[] = [];
  currentRole: { id: string; value: string } = { id: '', value: '' };
  projectDetails: Project = {} as Project;
  superAdminUrls: string[] = [];
  projectAdminUrls: string[] = [];
  lastRefreshDateUrls: string[] = [];
  showLastRefreshDate: boolean = false;
  previousUrl: string = '';
  searchText: string = '';
  private roleService = inject(RoleService);

  @ViewChild('nextRefreshHeaderTemplate')
  nextRefreshHeaderTemplate!: TemplateRef<any>;
  constructor(
    private router: Router,
    private authService: MsalService,
    private homePageService: HomePageService,
    private customAuthService: AuthService,
    private projectService: ProjectService,
    private historyService: HistoryService,
    private commonService: CommonService,
    private sanitizer: DomSanitizer
  ) {
    this.getFaqs();
    const allAccounts = this.authService.instance.getAllAccounts();
    this.userName = allAccounts.length ? allAccounts[0].name! : '';
    this.userEmail = allAccounts.length ? allAccounts[0].username! : '';
    this.superAdminUrls = SUPER_ADMIN_URLS;
    this.projectAdminUrls = PROJECT_ADMIN_URLS;

    this.lastRefreshDateUrls = LAST_REFRESH_DATE_URLS;
    this.customAuthService.setUserName(this.userName);
    this.customAuthService.setUserEmail(this.userEmail);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe({
        next: (event) => {
          this.currentPath = (event as any).url;
          this.showLastRefreshDate =
            this.currentPath != '/' &&
            !this.lastRefreshDateUrls.some((path) =>
              this.currentPath.includes(path)
            );

          this.checkRolesOnRouteChange();
          this.projectDetails = JSON.parse(
            localStorage.getItem('projectDetails')!
          );
          if (this.showLastRefreshDate) {
            this.loadLastRefreshedDate();
          }
          this.setProjectNameBasedOnRoute();
        },
      });
    // this.hasAccess = this.customAuthService.roleSubject.value.length > 0;
  }
  lastRefreshedDate: string = '';

  lastRefreshedDatasets: {
    columns: ColumnProps[];
    data: Record<string, any>[];
  } = { columns: [], data: [] };
  loading: boolean = false;
  isConcernTableLoading: boolean = false;
  isManualToggle: boolean = false;
  isLoading: boolean = false;
  monthFrom?: string;
  monthTo?: string;
  today?: string;
  isDialogVisible: boolean = false;
  projectName: string = 'Nerve Center';
  projectUid: string = '';
  initials: string = '';
  selectRoleVisible: boolean = false;
  selectedRoleId: string = '';
  faqVisible: boolean = false;
  faqData: FAQ[] = [];
  initialFaqData: FAQ[] = [];
  userPhoto: SafeUrl | null = '';

  fetchProjectName = () => {
    // this.projectNameService.getAssignedProjectNames().subscribe({
    //   next: (res) => {
    //     if (res?.data.length) {
    //       this.projectUid = res.data[0].uId;
    //       this.fetchProjectNameById(this.projectUid);
    //     }
    //   },
    //   error: (err) => {
    //     console.error(err);
    //   },
    // });
  };

  fetchProjectNameById = (uId: string) => {
    // TODO
    // this.projectNameService.getProjectNameById(uId).subscribe({
    //   next: (res) => {
    //     this.projectName = res.data.projectName;
    //   },
    //   error: (err) => {
    //     console.error(err);
    //   },
    // });
  };

  setInitials() {
    if (!this.userName) {
      this.initials = '';
    }

    const words = this.userName.trim().split(/\s+/); // Split by any whitespace
    this.initials = words
      .slice(0, 2)
      .map((word) => word[0].toUpperCase())
      .join('');
  }

  onRoleSelect(event: any) {
    this.currentRole = this.availableRoles.find(
      (role) => role.id === event.id
    )!;
    this.selectedRoleId = this.currentRole.id;
    this.roleService.setCurrentRole(this.currentRole);
    window.location.reload();
  }

  setProjectNameBasedOnRoute(): void {
    if (this.router.url === '/no-access') {
      this.projectName = 'Nerve Center';
    }
    if (!this.superAdminUrls.includes(this.router.url) && this.projectDetails) {
      this.projectName = this.projectDetails.projectName;
    } else {
      this.projectName = 'Nerve Center';
    }
  }

  checkRolesOnRouteChange() {
    this.projectDetails = this.projectService.getStoredProject();

    if (this.currentPath === '/') {
      this.currentRole = this.roleService.setPrecedenceRole()!;
      return;
    }

    if (this.superAdminUrls.includes(this.currentPath)) {
      if (this.roleService.isUserSuperAdmin()) {
        this.currentRole = this.roleService.getSuperAdminRole();
        this.roleService.setCurrentRole(this.currentRole);
      }
      return;
    }
    if (!this.projectDetails || !this.roleService.getCurrentRole()) {
      this.currentRole = this.roleService.setPrecedenceRole()!;
    } else {
      this.currentRole = this.roleService.getCurrentRole()!;
      this.availableRoles = this.roleService.getAvailableRoles(
        this.projectDetails.projectCode
      );
    }
  }

  getFaqs = () => {
    this.commonService.fetchFaqs().subscribe({
      next: (res) => {
        this.initialFaqData = res.data;
      },
    });
  };

  async ngOnInit() {
    // if (!this.hasAccess) return;
    this.setInitials();
    this.userPhoto = await this.customAuthService.getUserImage();
    this.projectDetails = this.projectService.getStoredProject();
    this.checkRolesOnRouteChange();
    // this.loadLastRefreshedDate();
    this.fetchProjectName();
    this.masterDataService.fetchAbbreviations().subscribe({
      next: (response) => {
        const abbreviationMap = response.data.reduce((acc, curr) => {
          acc[curr.abbreviationCode?.trim()] = curr.abbreviationName?.trim();
          return acc;
        }, {} as Record<string, string>);

        this.masterDataService.globalAbbreviations.next(abbreviationMap);
      },
    });

    console.log(
      'available roles',
      this.availableRoles,
      'Assigned roles:',
      this.roleService.getAssignedRoles(),
      'Current role:',
      this.roleService.getCurrentRole()
    );
  }

  onHideSideBar = () => {
    this.visible = false;
  };
  onShowSideBar = () => {
    this.visible = true;
  };

  toggleProfile = () => {
    this.isProfileOpen = !this.isProfileOpen;
    if (!this.isProfileOpen) {
      this.selectRoleVisible = false;
    }
  };

  loadLastRefreshedDate() {
    this.homePageService.refreshDetails(this.projectDetails.uId).subscribe({
      next: (response) => {
        if (response.data.data?.length) {
          const ordered = orderBy(response.data.data, ['lastRefreshDate']);
          const max = ordered[ordered.length - 1]['lastRefreshDate'];
          this.lastRefreshedDate = convertDateToCommonFormat(max);
          this.lastRefreshedDatasets = {
            data: response.data.data,
            columns: response.data.columns.map((el) => {
              if (el.field === 'nextRefreshDate') {
                return {
                  ...el,
                  headerTemplate: this.nextRefreshHeaderTemplate,
                };
              }
              return {
                ...el,
              };
            }),
          };
        }
      },
      error: (err) => {
        console.error('Error fetching last refreshed date:', err); // Handle any errors
      },
    });
  }

  onClickRefreshDate() {
    this.isDialogVisible = true;
  }

  onClosePopup = () => {
    if (!this.isDialogVisible) {
      return;
    }
    this.isDialogVisible = false;
  };

  goHome = () => {
    if (this.currentPath === '/assign-user') {
      return;
    }

    const isSuperAdminUrl = SUPER_ADMIN_URLS.includes(this.currentPath);

    const isProjectAdminUrl = PROJECT_ADMIN_URLS.some((url) =>
      this.currentPath.startsWith(url)
    );

    if (isSuperAdminUrl || isProjectAdminUrl) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['/home']);
    }
  };

  onLogoClick() {
    localStorage.removeItem('userTabType');
    localStorage.removeItem('userTabIndex');
    this.router.navigate(['/']);
    return;
  }

  logOut = async () => {
    await this.authService.instance.logout();
  };

  onSettings = () => {};
  onProfile = () => {};
  onSignOut = () => {
    this.authService.logout();
  };

  onFaqClick() {
    this.faqVisible = true;
    if (this.faqVisible) {
      this.searchText = '';
      this.faqData = this.initialFaqData
    }
  }

  onFaqClose = () => {
    this.faqVisible = false;
    this.faqData = [];
  };

  onSearch = (event: any) => {
    this.searchText = event.target.value;
    if (isEmpty(this.searchText)) {
      this.faqData = [];
    }
    this.faqData = this.initialFaqData
      .filter((faq) => {
        return (
          faq.question.toLowerCase().includes(this.searchText.toLowerCase()) ||
          faq.answer.toLowerCase().includes(this.searchText.toLowerCase())
        );
      });
  };

  highlightSearch(text: string, search: string): string {
    if (!search) return text;
    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp(`(${escaped})`, 'gi'), '<mark>$1</mark>');
  }
}
